import { Component, Input, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { Scene } from 'src/app/models/Scene';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { AuthorService } from 'src/app/services/author.service';
import { ModalService } from 'src/app/services/modal.service';
import { ProjectsService } from 'src/app/services/projects.service';

@Component({
  selector: 'app-hotspot-outcomes',
  templateUrl: './hotspot-outcomes.component.html',
  styleUrls: ['./hotspot-outcomes.component.scss'],
})
export class HotspotOutcomesComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;

  constructor(
    public authorService: AuthorService,
    public assetTypeService: AssetTypeService,
    public modalService: ModalService,
    public projectService: ProjectsService
  ) { }

  ngOnInit() {}

  displayOutcomeActionModal(assetInScene: AssetInScene) {
    if(this.authorService.autoSaveService.saving == true)
      return;

    var newAssetsCount: number = this.authorService.addedSceneAssetRelationIds.length;
      
    this.authorService.saveAddedSceneAssetRelations().then(async result => {
      this.authorService.clearArray(this.authorService.addedSceneAssetRelationIds);
      if (newAssetsCount > 0) {
        this.authorService.messagesService.presentToast('New media saved successfully!', 'success', 'Media');
      }
      setTimeout(() => { this.modalService.presentAssetOutcomeActions(this.projectService.project.projectId, assetInScene) }, 200);
    });
  }

}
